/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_State_ConflictInputs */

const cs_enum_state_conflict = /** @type {(inputs: Enum_State_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stále online na portálu`)
};

const en_enum_state_conflict = /** @type {(inputs: Enum_State_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still live on portal`)
};

/**
* | output |
* | --- |
* | "Still live on portal" |
*
* @param {Enum_State_ConflictInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_state_conflict = /** @type {((inputs?: Enum_State_ConflictInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_State_ConflictInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_state_conflict(inputs)
	return cs_enum_state_conflict(inputs)
});